<template>
  <Modal v-model="state" :title="plustitle" width="540" :mask-closable="false" class-name="vertical-center-modal">
    <Form :label-width="140">
      <FormItem label="月份" v-if="property(recordInfo.month)">
        <!-- :options="datetimeOption" -->
        <DatePicker
          type="month"
          v-model="recordInfo.month"
          placeholder="请选择"
          :disabled="edit"
          editable
          style="width: 180px"
          @on-change="setMonth"
        >
        </DatePicker>
      </FormItem>
      <FormItem label="游戏组" v-if="property(recordInfo.gameId)">
        <auto-complete
          v-model="recordInfo.gameId"
          :data="games"
          :disabled="edit"
          :popper-append-to-body="false"
          placeholder="全部"
          @on-select="handleGame"
        />
      </FormItem>
      <FormItem label="媒体" v-if="property(recordInfo.mediaId)">
        <auto-complete
          :data="medias"
          v-model="recordInfo.mediaId"
          :disabled="edit"
          :popper-append-to-body="false"
          placeholder="全部"
          @on-select="handleMedia"
        ></auto-complete>
      </FormItem>
      <FormItem label="30KPI" v-if="property(recordInfo.roi1)">
        <span class="sub-item">ROI1</span>
        <input-number-plus
          v-model="recordInfo.roi1"
          :maxNum="100"
          :max="3"
          :min="0.01"
          :precision="2"
          :width="180"
          @on-blur="updateRoi"
          placeholder="请输入0.01-100值，最多2位小数"
        />
        <span class="c-unit"> %</span>
      </FormItem>
      <FormItem v-if="property(recordInfo.roi2)">
        <span class="sub-item">ROI2</span>
        <input-number-plus
          v-model="recordInfo.roi2"
          :maxNum="100"
          :max="3"
          :min="0.01"
          :precision="2"
          :width="180"
          @on-blur="updateRoi"
          placeholder="请输入0.01-100值，最多2位小数"
        />
        <span class="c-unit"> %</span>
      </FormItem>
      <FormItem v-if="property(recordInfo.roi3)">
        <span class="sub-item">ROI3</span>
        <input-number-plus
          v-model="recordInfo.roi3"
          :maxNum="100"
          :max="3"
          :min="0.01"
          :precision="2"
          :width="180"
          @on-blur="updateRoi"
          placeholder="请输入0.01-100值，最多2位小数"
        />
        <span class="c-unit"> %</span>
      </FormItem>
      <FormItem v-if="property(recordInfo.roi4)">
        <span class="sub-item">ROI4</span>
        <input-number-plus
          v-model="recordInfo.roi4"
          :maxNum="100"
          :max="3"
          :min="0.01"
          :precision="2"
          :width="180"
          @on-blur="updateRoi"
          placeholder="请输入0.01-100值，最多2位小数"
        />
        <span class="c-unit"> %</span>
      </FormItem>
      <FormItem v-if="property(recordInfo.roi5)">
        <span class="sub-item">ROI5</span>
        <input-number-plus
          v-model="recordInfo.roi5"
          :maxNum="100"
          :max="3"
          :min="0.01"
          :precision="2"
          :width="180"
          @on-blur="updateRoi"
          placeholder="请输入0.01-100值，最多2位小数"
        />
        <span class="c-unit"> %</span>
      </FormItem>
      <FormItem label="是否特殊提成" v-if="property(recordInfo.isSpecial)">
        <i-Switch v-model="recordInfo.isSpecial" :true-value="1" :false-value="2"></i-Switch>
      </FormItem>
      <FormItem label="CP分成比例" v-if="property(recordInfo.divide)">
        <Input
          v-model.trim="recordInfo.divide"
          placeholder="请输入0.01-100值，最多2位小数"
          style="width: 180px"
          @on-blur="toFloat('divide', recordInfo, true)"
        />
        <span class="c-unit"> %</span>
      </FormItem>
    </Form>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="$emit('on-save', recordInfo)">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { mul, div } from '@/common/js/api'
import { formatDate, isEmpty } from '@/common/js/utils'
import AutoComplete from '@/components/autocomplete/autocomplete'
import InputNumberPlus from '@/components/input/input-number-plus'
export default {
  name: 'setRecord',
  components: { AutoComplete, InputNumberPlus },
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    games: {
      type: Array,
      default() {
        return []
      }
    },
    medias: {
      type: Array,
      default() {
        return []
      }
    },
    info: {
      type: Object
    },
    edit: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    property() {
      return (val) => val !== undefined
    },
    plustitle() {
      return `${this.edit ? '修改' : '新增'}${this.title}`
    }
  },
  watch: {
    info: {
      handler(nVal) {
        this.updateInfo()
      },
      deep: true
    }
  },
  methods: {
    updateInfo() {
      this.info.month = formatDate(new Date(this.info.month), 'yyyy-MM')
      this.$set(this, 'recordInfo', this.info)
    },
    handleGame(meta) {
      this.recordInfo.gameId = meta.id
    },
    handleMedia(meta) {
      this.recordInfo.mediaId = meta.id
    },
    setMonth(val) {
      this.recordInfo.month = val
    },
    toFloat(key, obj, fixed) {
      if (isEmpty(obj[key])) return
      let val = parseFloat(obj[key])
      if (isNaN(val)) val = ''
      else if (val < 0) val = 0
      else if (fixed) {
        val = mul(val, 100)
        val = div(Math.floor(val), 100)
      }
      obj[key] = val
      this.$forceUpdate()
    },
    updateRoi(val, index) {
      this.$forceUpdate()
    }
  },
  data() {
    return {
      recordInfo: {
        roi1: ''
      },
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInfo()
    })
  }
}
</script>
<style lang="scss" scoped>
.c-unit {
  padding-left: 8px;
}
</style>
